export default (languageCode: string) => /* GraphQL */ `
    query GetLists {
        lists(itemPresentation: { languageCode: "${languageCode}" }) {
            isSelected
            listId
            name
            updated
            quantity
            designs {
                configurationId
            }
            items {
                itemNo
                quantity
                product {
                    images {
                        url
                        quality
                    }
                    globalName
                }
            }
        }
    }
`;
